<!-- Only show the full admin bar for full admins, not enterprise managers -->
<nav class="navbar navbar-expand-lg navbar-dark bg-dark p-0" *ngIf="authService.isAdmin">
    <div class="container-fluid">
        <div class="navbar-header">
            <a class="navbar-brand" href="/Home">Admin</a>
        </div>

        <button
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
            class="navbar-toggler d-block d-md-none"
            data-bs-target="#navbarSupportedContent"
            data-bs-toggle="collapse"
            type="button"
        >
            <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav me-auto mb-2 mb-lg-0">
                <li class="nav-item">
                    <a [routerLink]="['/admin/dashboard']" aria-current="page" class="nav-link" routerLinkActive="active"><i class="fa-solid fa-gauge-high"></i> Dashboard</a>
                </li>
                <li class="nav-item dropdown" routerLinkActive="dropdown-active">
                    <a aria-expanded="false" class="nav-link dropdown-toggle" data-bs-toggle="dropdown" role="button"><i class="fa-solid fa-chart-pie"></i> Reports</a>
                    <ul class="dropdown-menu">
                        <li>
                            <a [routerLink]="['/admin/building-allocations']" class="dropdown-item" routerLinkActive="active"><i class="fa-solid fa-location-dot"></i> Building Allocations</a>
                            <a [routerLink]="['/admin/market-insights']" class="dropdown-item" routerLinkActive="active"><i class="fa-solid fa-city"></i> Market Insights</a>
                            <a [routerLink]="['/admin/heat-map']" class="dropdown-item" routerLinkActive="active"><i class="fa-solid fa-fire"></i> Heat Map</a>
                        </li>
                        <li><hr class="dropdown-divider" /></li>
                        <li>
                            <a [routerLink]="['/admin/insights']" class="dropdown-item" routerLinkActive="active"><i class="fa-solid fa-lightbulb"></i> Old Dashboard</a>
                        </li>
                        <li>
                            <a [routerLink]="['/admin/line-charts']" class="dropdown-item" routerLinkActive="active"><i class="fa-solid fa-chart-line"></i> Line Charts</a>
                        </li>
                        <li>
                            <a [routerLink]="['/admin/rejections']" class="dropdown-item" routerLinkActive="active"><i class="fa-solid fa-ban"></i> Rejections</a>
                        </li>
                        <li><hr class="dropdown-divider" /></li>
                        <li>
                            <a [routerLink]="['/admin/searches-report']" class="dropdown-item" routerLinkActive="active"><i class="fa-solid fa-map"></i> Searches by Province</a>
                        </li>
                        <li>
                            <a [routerLink]="['/admin/searches-table']" class="dropdown-item" routerLinkActive="active"><i class="fa-solid fa-city"></i> Searches by City</a>
                        </li>
                        <li>
                            <a [routerLink]="['/admin/companies-by-client']" class="dropdown-item" routerLinkActive="active"><i class="fa-solid fa-building"></i> Companies by client</a>
                        </li>
                    </ul>
                </li>
                <li class="nav-item dropdown" routerLinkActive="dropdown-active">
                    <a aria-expanded="false" class="nav-link dropdown-toggle" data-bs-toggle="dropdown" role="button"><i class="fa-solid fa-bullhorn"></i> Marketing</a>
                    <ul class="dropdown-menu">
                        <li>
                            <a [routerLink]="['/admin/marketing-health']" class="dropdown-item" routerLinkActive="active"><i class="fa-solid fa-chart-line"></i> Marketing Health</a>
                        </li>
                        <li>
                            <a [routerLink]="['/admin/ad-conversions']" class="dropdown-item" routerLinkActive="active"><i class="fa-solid fa-bullseye"></i> Ad Conversions</a>
                        </li>
                        <li><hr class="dropdown-divider" /></li>
                        <li>
                            <a [routerLink]="['/admin/campaigns']" class="dropdown-item" routerLinkActive="active"><i class="fa-solid fa-flag"></i> Campaigns</a>
                        </li>
                        <li>
                            <a [routerLink]="['/admin/clusters']" class="dropdown-item" routerLinkActive="active"><i class="fa-solid fa-layer-group"></i> Clusters</a>
                        </li>
                        <li><hr class="dropdown-divider" /></li>
                        <li>
                            <a [routerLink]="['/admin/affiliates']" class="dropdown-item" routerLinkActive="active"><i class="fa-solid fa-handshake"></i> Affiliates</a>
                        </li>
                    </ul>
                </li>
                <li class="nav-item dropdown" routerLinkActive="dropdown-active">
                    <a aria-expanded="false" class="nav-link dropdown-toggle" data-bs-toggle="dropdown" role="button"><i class="fa-solid fa-pen-to-square"></i> CMS</a>
                    <ul class="dropdown-menu">
                        <li>
                            <a [routerLink]="['/admin/cms/blogs']" class="dropdown-item" routerLinkActive="active"><i class="fa-solid fa-newspaper"></i> Blogs</a>
                        </li>
                        <li>
                            <a [routerLink]="['/admin/cms/faqs']" class="dropdown-item" routerLinkActive="active"><i class="fa-solid fa-circle-question"></i> FAQs</a>
                        </li>
                    </ul>
                </li>
                <li class="nav-item dropdown" routerLinkActive="dropdown-active">
                    <a aria-expanded="false" class="nav-link dropdown-toggle" data-bs-toggle="dropdown" role="button"><i class="fa-solid fa-address-book"></i> Parker CRM</a>
                    <ul class="dropdown-menu">
                        <li>
                            <a [routerLink]="['/admin/parker-crm/users']" class="dropdown-item" routerLinkActive="active"><i class="fa-solid fa-users"></i> User List</a>
                        </li>
                        <li><hr class="dropdown-divider" /></li>
                        <li>
                            <a [routerLink]="['/admin/parker-crm/board']" class="dropdown-item" routerLinkActive="active"><i class="fa-solid fa-columns"></i> CRM Board</a>
                        </li>
                        <li>
                            <a [routerLink]="['/admin/parker-crm/table']" class="dropdown-item" routerLinkActive="active"><i class="fa-solid fa-table"></i> CRM Table</a>
                        </li>
                        <li>
                            <a [routerLink]="['/admin/parker-crm/stats']" class="dropdown-item" routerLinkActive="active"><i class="fa-solid fa-chart-bar"></i> CRM Stats</a>
                        </li>
                    </ul>
                </li>
                <li class="nav-item" routerLinkActive="active">
                    <a [routerLink]="['/admin/expiring-leases']" class="nav-link" routerLinkActive="active"><i class="fa-solid fa-hourglass-half"></i> Expiring Leases</a>
                </li>
                <li class="nav-item" routerLinkActive="active">
                    <a [routerLink]="['/admin/prospecting']" class="nav-link" routerLinkActive="active"><i class="fa-solid fa-magnifying-glass-location"></i> Prospecting</a>
                </li>
                <li class="nav-item dropdown" routerLinkActive="dropdown-active">
                    <a aria-expanded="false" class="nav-link dropdown-toggle" data-bs-toggle="dropdown" role="button"><i class="fa-solid fa-square-parking"></i> Admyt</a>
                    <ul class="dropdown-menu">
                        <li>
                            <a [routerLink]="['/admin/admyt-centers']" class="dropdown-item" routerLinkActive="active"><i class="fa-solid fa-location-dot"></i> Admyt Centers</a>
                        </li>
                        <li>
                            <a [routerLink]="['/admin/admyt-tenants']" class="dropdown-item" routerLinkActive="active"><i class="fa-solid fa-id-card"></i> Admyt Tenants</a>
                        </li>
                        <li>
                            <a [routerLink]="['/admin/admyt-users']" class="dropdown-item" routerLinkActive="active"><i class="fa-solid fa-users"></i> Admyt Users</a>
                        </li>
                        <li><hr class="dropdown-divider" /></li>
                        <li>
                            <a [routerLink]="['/admin/admyt-audit']" class="dropdown-item" routerLinkActive="active"><i class="fa-solid fa-magnifying-glass-chart"></i> Audit</a>
                        </li>
                        <li>
                            <a [routerLink]="['/admin/admyt-logs']" class="dropdown-item" routerLinkActive="active"><i class="fa-solid fa-file-alt"></i> API Logs</a>
                        </li>
                    </ul>
                </li>
                <li class="nav-item dropdown" routerLinkActive="dropdown-active">
                    <a aria-expanded="false" class="nav-link dropdown-toggle" data-bs-toggle="dropdown" role="button"><i class="fa-solid fa-coins"></i> Accounts</a>
                    <ul class="dropdown-menu">
                        <li>
                            <a [routerLink]="['/admin/invoice-payouts']" class="dropdown-item" routerLinkActive="active"><i class="fa-solid fa-money-bill-transfer"></i> 1. Invoice Payouts</a>
                        </li>
                        <li>
                            <a [routerLink]="['/admin/payouts']" class="dropdown-item" routerLinkActive="active"><i class="fa-solid fa-file-invoice"></i> 2. Proforma Invoices</a>
                        </li>
                        <li>
                            <a [routerLink]="['/admin/payout-batches']" class="dropdown-item" routerLinkActive="active"><i class="fa-solid fa-boxes-stacked"></i> 3. Payout Batches</a>
                        </li>
                        <li>
                            <a [routerLink]="['/admin/affiliate-payouts']" class="dropdown-item" routerLinkActive="active"><i class="fa-solid fa-handshake"></i> Affiliate Payouts</a>
                        </li>
                        <li><hr class="dropdown-divider" /></li>
                        <li>
                            <a [routerLink]="['/admin/financial-health']" class="dropdown-item" routerLinkActive="active"><i class="fa-solid fa-heart-pulse"></i> Financial Health</a>
                        </li>
                        <li>
                            <a [routerLink]="['/admin/monthly-dashboard']" class="dropdown-item" routerLinkActive="active"><i class="fa-solid fa-calculator"></i> Monthly Dashboard</a>
                        </li>
                    </ul>
                </li>
                <li class="nav-item dropdown" routerLinkActive="dropdown-active">
                    <a aria-expanded="false" class="nav-link dropdown-toggle" data-bs-toggle="dropdown" role="button"><i class="fa-solid fa-eye"></i> Transparency</a>
                    <ul class="dropdown-menu">
                        <li>
                            <a [routerLink]="['/admin/transparency']" class="dropdown-item" routerLinkActive="active" [queryParams]="{section: 'admyt'}"><i class="fa-solid fa-shield-halved"></i> Admyt Integration</a>
                        </li>
                        <li>
                            <a [routerLink]="['/admin/data-hygiene']" class="dropdown-item" routerLinkActive="active"><i class="fa-solid fa-broom"></i> Data Hygiene</a>
                        </li>
                        <li>
                            <a [routerLink]="['/admin/affiliate-guide']" class="dropdown-item" routerLinkActive="active"><i class="fa-solid fa-handshake"></i> Affiliate Programme Guide</a>
                        </li>
                    </ul>
                </li>
                <li class="nav-item dropdown" routerLinkActive="dropdown-active">
                    <a aria-expanded="false" class="nav-link dropdown-toggle" data-bs-toggle="dropdown" role="button"><i class="fa-solid fa-gear"></i> System</a>
                    <ul class="dropdown-menu dropdown-menu-end mega-dropdown">
                        <li>
                            <a [routerLink]="['/admin/users']" class="dropdown-item" routerLinkActive="active"><i class="fa-solid fa-users"></i> Users</a>
                        </li>
                        <li>
                            <a [routerLink]="['/admin/access-audit']" class="dropdown-item" routerLinkActive="active"><i class="fa-solid fa-clipboard-check"></i> Access Audit</a>
                        </li>
                        <li>
                            <a [routerLink]="['/admin/functions']" class="dropdown-item" routerLinkActive="active"><i class="fa-solid fa-wand-magic-sparkles"></i> Admin Functions</a>
                        </li>
                        <li>
                            <a [routerLink]="['/admin/enterprise-management']" class="dropdown-item" routerLinkActive="active"><i class="fa-solid fa-building-columns"></i> Enterprise Management</a>
                        </li>
                        <li>
                            <a [routerLink]="['/admin/deputize']" class="dropdown-item" routerLinkActive="active"><i class="fa-solid fa-user-secret"></i> Deputize</a>
                        </li>
                        <li>
                            <a [routerLink]="['/admin/global-variables']" class="dropdown-item" routerLinkActive="active"><i class="fa-solid fa-sliders"></i> Global Variables</a>
                        </li>
                        <li>
                            <a [routerLink]="['/admin/test-routes']" class="dropdown-item" routerLinkActive="active"><i class="fa-solid fa-clock"></i> Cron Jobs & Functions</a>
                        </li>
                        <li>
                            <a [routerLink]="['/admin/omnisend-errors']" class="dropdown-item" routerLinkActive="active"><i class="fa-solid fa-envelope-open-text"></i> Omnisend Errors</a>
                        </li>
                        <li>
                            <a [routerLink]="['/admin/changelog']" class="dropdown-item" routerLinkActive="active"><i class="fa-solid fa-code-branch"></i> Changelog</a>
                        </li>

                        <!-- Emails Submenu -->
                        <li class="dropdown-submenu">
                            <a class="dropdown-item dropdown-toggle" role="button"><i class="fa-solid fa-envelope"></i> Emails <i class="fa-solid fa-chevron-right submenu-arrow"></i></a>
                            <ul class="submenu">
                                <li>
                                    <a [routerLink]="['/admin/emails']" class="dropdown-item" routerLinkActive="active"><i class="fa-solid fa-envelope"></i> All Emails</a>
                                </li>
                                <li>
                                    <a [routerLink]="['/admin/emails-by-subject']" class="dropdown-item" routerLinkActive="active"><i class="fa-solid fa-envelopes-bulk"></i> Emails by Subject Line</a>
                                </li>
                            </ul>
                        </li>

                        <!-- VAT 201 Submenu -->
                        <li class="dropdown-submenu">
                            <a class="dropdown-item dropdown-toggle" role="button"><i class="fa-solid fa-receipt"></i> VAT 201 <i class="fa-solid fa-chevron-right submenu-arrow"></i></a>
                            <ul class="submenu">
                                <li>
                                    <a [routerLink]="['/admin/invoices-list']" class="dropdown-item" routerLinkActive="active"><i class="fa-solid fa-receipt"></i> VAT Invoices</a>
                                </li>
                                <li>
                                    <a [routerLink]="['/admin/proforma-invoices-list']" class="dropdown-item" routerLinkActive="active"><i class="fa-solid fa-file-lines"></i> VAT Proforma Invoices</a>
                                </li>
                                <li>
                                    <a [routerLink]="['/admin/old-invoices-list']" class="dropdown-item" routerLinkActive="active"><i class="fa-solid fa-clock-rotate-left"></i> Old Invoice System</a>
                                </li>
                            </ul>
                        </li>

                        <!-- Developer Submenu -->
                        <li class="dropdown-submenu">
                            <a class="dropdown-item dropdown-toggle" role="button"><i class="fa-solid fa-code"></i> Developer <i class="fa-solid fa-chevron-right submenu-arrow"></i></a>
                            <ul class="submenu">
                                <li>
                                    <a [routerLink]="['/admin/migrations']" class="dropdown-item" routerLinkActive="active"><i class="fa-solid fa-database"></i> Migrations</a>
                                </li>
                                <li>
                                    <a [routerLink]="['/admin/exceptions']" class="dropdown-item" routerLinkActive="active"><i class="fa-solid fa-bug"></i> Exceptions</a>
                                </li>
                                <li>
                                    <a [routerLink]="['/admin/known-issues']" class="dropdown-item" routerLinkActive="active"><i class="fa-solid fa-clipboard-list"></i> Known Issues</a>
                                </li>
                                <li>
                                    <a [routerLink]="['/admin/list-payments']" class="dropdown-item" routerLinkActive="active"><i class="fa-solid fa-hand"></i> Possible Held Payments</a>
                                </li>
                                <li>
                                    <a [routerLink]="['/admin/void-payment']" class="dropdown-item" routerLinkActive="active"><i class="fa-solid fa-trash-can"></i> Force Void Payment</a>
                                </li>
                                <li>
                                    <a [routerLink]="['/admin/test-local']" class="dropdown-item" routerLinkActive="active"><i class="fa-solid fa-flask"></i> Test Local Functions</a>
                                </li>
                                <!-- Test Token Payment disabled (temporary testing page)
                                <li>
                                    <a [routerLink]="['/admin/test-payment']" class="dropdown-item" routerLinkActive="active"><i class="fa-solid fa-credit-card"></i> Test Token Payment</a>
                                </li>
                                -->
                                <li>
                                    <a [routerLink]="['/admin/paygate-lab']" class="dropdown-item" routerLinkActive="active"><i class="fa-solid fa-flask"></i> PayGate Lab</a>
                                </li>
                                <li>
                                    <a [routerLink]="['/admin/paygate-attempts']" class="dropdown-item" routerLinkActive="active"><i class="fa-solid fa-list-check"></i> PayGate Attempts</a>
                                </li>
                            </ul>
                        </li>

                        <!-- Archived Submenu -->
                        <li class="dropdown-submenu">
                            <a class="dropdown-item dropdown-toggle" role="button"><i class="fa-solid fa-box-archive"></i> Archived <i class="fa-solid fa-chevron-right submenu-arrow"></i></a>
                            <ul class="submenu">
                                <li>
                                    <a [routerLink]="['/admin/old-leads']" class="dropdown-item" routerLinkActive="active"><i class="fa-solid fa-user-plus"></i> Old Leads</a>
                                </li>
                                <li>
                                    <a [routerLink]="['/admin/recon']" class="dropdown-item" routerLinkActive="active"><i class="fa-solid fa-scale-balanced"></i> Income Recon</a>
                                </li>
                                <li>
                                    <a [routerLink]="['/admin/merchant-users-private']" class="dropdown-item" routerLinkActive="active"><i class="fa-solid fa-users"></i> Merchant Members</a>
                                </li>
                                <li>
                                    <a [routerLink]="['/admin/merchant-member-invites']" class="dropdown-item" routerLinkActive="active"
                                        ><i class="fa-solid fa-envelope-open-text"></i> Merchant Member Invites</a
                                    >
                                </li>
                                <li>
                                    <a [routerLink]="['/admin/settlements']" class="dropdown-item" routerLinkActive="active"><i class="fa-solid fa-handshake"></i> Settlements</a>
                                </li>
                                <li>
                                    <a [routerLink]="['/admin/searches']" class="dropdown-item" routerLinkActive="active"><i class="fa-solid fa-magnifying-glass"></i> Searches</a>
                                </li>
                                <li>
                                    <a [routerLink]="['/admin/scan']" class="dropdown-item" routerLinkActive="active"><i class="fa-solid fa-qrcode"></i> Scan QR</a>
                                </li>
                                <li>
                                    <a [routerLink]="['/admin/duplicate-invoices']" class="dropdown-item" routerLinkActive="active"><i class="fa-solid fa-copy"></i> Duplicate First Invoices</a>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </li>
            </ul>
            <ul class="navbar-nav ms-auto">
                <li class="nav-item">
                    <a [routerLink]="['/admin/profile']" class="nav-link" routerLinkActive="active" title="My Profile"><i class="fa-solid fa-user-circle"></i> Profile</a>
                </li>
            </ul>
        </div>
    </div>
</nav>

<div
    class="context-menu"
    id="context-menu"
    *ngIf="globalService.contextMenuVisible"
    [style.left.px]="globalService.contextMenuX"
    [style.top.px]="globalService.contextMenuY"
    (mouseenter)="globalService.cancelContextMenuHide()"
    (mouseleave)="globalService.hideContextMenuDelayed(200)"
>
    <ul class="context-menu-list">
        <li
            class="context-menu-item"
            [class.context-menu-item--has-submenu]="item.subMenuItems?.length"
            [class.context-menu-item--header]="item.isHeader"
            *ngFor="let item of globalService.contextMenuItems"
            (click)="!item.subMenuItems?.length && !item.isHeader && item.action(); globalService.hideContextMenu()"
        >
            <a><i *ngIf="item.icon" [class]="item.icon"></i> {{ item.label }}</a>
            <ul *ngIf="item.subMenuItems?.length" class="context-submenu-list">
                <li class="context-submenu-item" *ngFor="let subItem of item.subMenuItems" (click)="subItem.action(); globalService.hideContextMenu(); $event.stopPropagation()">
                    <a><i *ngIf="subItem.icon" [class]="subItem.icon"></i> {{ subItem.label }}</a>
                </li>
            </ul>
        </li>
    </ul>
</div>
